import { Observable, BehaviorSubject } from "rxjs";
import { of } from "rxjs/observable/of";
import { filter, take, map, tap, catchError } from "rxjs/operators";

export abstract class ApiCallQueueingServiceBase<T> {

    private isRetrieving = false;
    private retrievalSubject = new BehaviorSubject<() => T>(null);

    constructor(private apiCall: () => Observable<T>) { }

    protected retrieveOrWait(): Observable<T> {
        if (!this.isRetrieving) {
            return this.retrieve();
        }
        else {
            return this.waitForRetrieval();
        }
    }

    private retrieve(): Observable<T> {
        this.isRetrieving = true;
        this.retrievalSubject.next(null);

        return this.apiCall().pipe(
            tap(result => {
                this.isRetrieving = false;
                this.retrievalSubject.next(() => result);
            }),
            catchError(() => {
                this.isRetrieving = false;
                this.retrievalSubject.next(() => undefined);
                return of<T>(undefined);
            }));
    }

    private waitForRetrieval(): Observable<T> {
        return this.retrievalSubject.pipe(
            filter(func => func != null),
            take(1),
            map(func => func()));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/api-call-queueing-service-base.ts